<template>
    <div class="gray-back" style="padding:.2rem 0 8rem 0">
        <van-form
                @submit="onSubmit"
                @failed="onFailed"
        >
            <van-divider>确认发票信息</van-divider>


            <van-cell-group>

                <van-field
                        v-model="formData.danwei"
                        :rules="[{ required: true, message: '发票抬头不能为空' }]"
                        label="发票抬头"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="请输入发票抬头"
                />
                <van-field
                        v-model="formData.danwei"
                        :rules="[{ required: true, message: '税号不能为空' }]"
                        label="税号"
                        :border="false"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="请输入税号"
                />
                <div class="operate-desc-left">如果您所在的单位没有纳税人识别号请填写“无”</div>

                <van-field
                        v-model="formData.danwei"
                        label="发票备注"
                        input-align="right"
                        clearable
                        placeholder="请输入发票备注"
                />
                <van-field
                        v-model="formData.danwei"
                        label="接收邮箱"
                        input-align="right"
                        clearable
                        placeholder="请输入接收邮箱"
                />
                <van-field
                        v-model="formData.danwei"
                        label="接送手机"
                        input-align="right"
                        clearable
                        placeholder="请输入接送手机"
                />

                <div class="fapiao-tip-wrap">
                    <div>
                        发票1 金额：1200元  名目：赛事综合服务费
                    </div>
                    <div>
                        发票2 金额：1200元  名目：赛事综合服务费
                    </div>
                </div>
                <div style="text-align: center">
                    <van-button
                            style="width: 3rem; margin: 10px;"
                            size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="保存中..." native-type="submit" @click="save">确认发票信息</van-button>
                </div>

            </van-cell-group>


            <van-divider>费用信息</van-divider>

            <van-cell-group>

                <van-cell
                        input-align="right"
                        is-link
                        title="赛事综合服务费"
                        value="1"
                />
                <van-cell
                        input-align="right"
                        is-link
                        title="食宿费"
                        value="1"
                />
                <van-cell
                        input-align="right"
                        is-link
                        title="其他服务费"
                        value="1"
                />
                <van-cell
                        input-align="right"
                        is-link
                        title="费用总计"
                        value="1"
                />

            </van-cell-group>


            <div class="savebtn">
                <van-button
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="保存中..." native-type="submit" @click="save">暂存信息</van-button>

                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">提交申请</van-button>
            </div>
        </van-form>



    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }

    .fapiao-tip-wrap{
        background: #F3F3F3;
        margin: 0.2rem;
        border-radius: 8px;
        line-height: 36px;
        padding: 0.2rem;
        font-size: 14px;
        color: #666;
    }
    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import FileUploader from '@/components/picker/FileUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,ActionSheet,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import FamliyPicker from '@/components/picker/FamliyPicker.vue';


    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'SaiApplyFormStep2',
        components: {
            [Field.name]: Field,
            PicUploader,
            FileUploader,
        },
        data: function () {
            return {
                validator,
                saveLoading:false,
                showFamliyPicker:false,
                showSubjectPicker:false,
                showJiaolianPicker:false,
                showRoomTypePicker:false,
                showMemberPicker:false,
                roomTypeColumns: ['标间', '单人间'],
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                subjectName:'',
                subjectArray:[],
                subjectOptions:[],
                subjectOptionsAll: [
                    {
                        name: '幼儿组',
                        children: [
                            {
                                name: '幼儿组',
                                children: [{ name: '舞蹈啦啦操',
                                    children:[
                                        {
                                            name: '花球规定动作',
                                        },
                                        {
                                            name: '222',
                                        }
                                    ] }, {
                                    name: '余杭区',
                                    children:[
                                        {
                                            name: '111',
                                        },
                                        {
                                            name: '222',
                                        }
                                    ]
                                }],
                            },
                            {
                                name: '温州',
                                children: [{ name: '鹿城区' }, { name: '瓯海区' }],
                            },
                        ],
                    },
                    {
                        name: '福建',
                        children: [
                            {
                                name: '福州',
                                children: [{ name: '鼓楼区' }, { name: '台江区' }],
                            },
                            {
                                name: '厦门',
                                children: [{ name: '思明区' }, { name: '海沧区' }],
                            },
                        ],
                    },
                ],
                formData: {
                    id: 0,
                    saiqu_name:'xxxxx',
                    danwei:'xxxxx',
                    caipan:[],
                    music:[],
                    famliy:[],
                    tbydy:[],
                    jiaolian:[],
                    member:[],
                    areas:'',
                    province:'',
                    city:'',
                    county:'',
                    kaojitype:'考级中心',
                    changdipic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
                    zhizhaopic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
                },
            }
        },
        filters: {},
        mounted() {
            let that = this;
            that.areaList = area;
            that.formData.id = this.$route.query.id;
            if(that.formData.id){
                this.fetch();
            }
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            onMemberConfirm(values){
                console.log('onMemberConfirm',values)
                this.showMemberPicker = false;
                this.formData.member = [...values];
            },
            onMemberChange(values){
                console.log('onMemberChange',values)
                this.formData.member = [...values];
            },
            onRoomTypeConfirm(value, index){
                this.formData.roomTypeName = value;
                this.formData.roomtype = index+1;
                this.showRoomTypePicker = false;
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                for (let field in that.formData) {

                    if (that.formData.changdipic.length == 0) {
                        Toast('请上传场地照片');
                        return
                    }
                    if (that.formData.zhizhaopic.length == 0) {
                        Toast('请上传单位执照');
                        return
                    }
                    if (!this.formData.area) {
                        Toast('请选择地区');
                        return
                    }
                }
                that.saveLoading = true;

                if (that.submitType =='save') {
                    that.$api.post('/api/examecenter/save', that.formData, (res) => {
                        that.saveLoading = false;
                    }, (res) => {
                        Toast.fail(res.msg);
                        that.saveLoading = false;
                    })
                } else {
                    that.$api.post('/api/examecenter/apply', that.formData, (res) => {
                        that.saveLoading = false;
                    }, (res) => {
                        Toast.fail(res.msg);
                        that.saveLoading = false;
                    })
                }
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            fetch(){
                let that = this;
                that.$api.post('/api/examecenter/centerdetail', {
                    id:that.formData.id
                }, (res) => {
                    that.formData = res.data;
                }, (res) => {
                    Toast.fail(res.msg);
                })
            }

        }
    }
</script>



// WEBPACK FOOTER //
// SaiApplyFormStep5.vue?011e678e